"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports._XPathResult = void 0;
var _html = _interopRequireDefault(require("./html"));
var _word = _interopRequireDefault(require("./word"));
var _gdocs = _interopRequireDefault(require("./gdocs"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// We need this here if run server side
var _XPathResult = {
  ANY_TYPE: 0,
  NUMBER_TYPE: 1,
  STRING_TYPE: 2,
  BOOLEAN_TYPE: 3,
  UNORDERED_NODE_ITERATOR_TYPE: 4,
  ORDERED_NODE_ITERATOR_TYPE: 5,
  UNORDERED_NODE_SNAPSHOT_TYPE: 6,
  ORDERED_NODE_SNAPSHOT_TYPE: 7,
  ANY_UNORDERED_NODE_TYPE: 8,
  FIRST_ORDERED_NODE_TYPE: 9
};
exports._XPathResult = _XPathResult;
var _default = [_word.default, _gdocs.default, _html.default];
exports.default = _default;